import React, { useState } from 'react';
import NotificationBell from '../ui/NotificationBell';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

function PopupContribuer({ onClose }) {
  const presets = [5, 10, 20, 50];
  const [amount, setAmount] = useState(10);
  const [custom, setCustom] = useState('');
  const [donorName, setDonorName] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');
  const finalAmount = custom !== '' ? Number(custom) : amount;

  const handleDon = async () => {
    setErr('');
    const a = Number(finalAmount);
    if (!a || isNaN(a) || a < 1) { setErr('Choisissez un montant valide (1 € minimum).'); return; }
    setLoading(true);
    try {
      const res = await fetch('/api/donations/create-checkout-session', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ amount: a, donorName, message })
      });
      const data = await res.json();
      if (res.ok && data.url) { window.location.href = data.url; }
      else { setErr(data.message || 'Une erreur est survenue.'); setLoading(false); }
    } catch (e) { setErr('Connexion impossible. Réessayez.'); setLoading(false); }
  };

  const chip = (active) => ({ padding: '10px 0', textAlign: 'center', borderRadius: '8px', border: active ? '1.5px solid #8b1a2a' : '1px solid #dccfc8', background: active ? '#fdf2f3' : '#fff', color: active ? '#8b1a2a' : '#6a5050', fontWeight: active ? '600' : '400', fontSize: '14px', cursor: 'pointer' });

  return (
    <div onClick={onClose} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: '16px', padding: '28px', maxWidth: '380px', width: '100%', boxShadow: '0 20px 60px rgba(0,0,0,0.3)', maxHeight: '90vh', overflowY: 'auto' }}>
        <div style={{ fontSize: '34px', textAlign: 'center', marginBottom: '8px' }}>♥</div>
        <h3 style={{ fontFamily: 'Georgia,serif', fontSize: '19px', color: '#1a1010', textAlign: 'center', margin: '0 0 8px' }}>Aidez-nous à garder ce site gratuit et sans pub</h3>
        <p style={{ fontSize: '13px', color: '#6a5050', lineHeight: '1.6', textAlign: 'center', margin: '0 0 20px' }}>Chaque contribution, même petite, aide à maintenir cet espace vivant.</p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '8px', marginBottom: '12px' }}>
          {presets.map(p => (
            <div key={p} onClick={() => { setAmount(p); setCustom(''); }} style={chip(custom === '' && amount === p)}>{p} €</div>
          ))}
        </div>
        <div style={{ position: 'relative', marginBottom: '12px' }}>
          <input value={custom} onChange={e => setCustom(e.target.value.replace(/[^0-9.]/g, ''))} placeholder="Autre montant" inputMode="decimal" style={{ width: '100%', boxSizing: 'border-box', padding: '10px 30px 10px 12px', border: '1px solid #dccfc8', borderRadius: '8px', fontSize: '14px' }} />
          <span style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', color: '#9a8080', fontSize: '14px' }}>€</span>
        </div>
        <input value={donorName} onChange={e => setDonorName(e.target.value)} placeholder="Votre nom (optionnel, affiché)" style={{ width: '100%', boxSizing: 'border-box', padding: '10px 12px', border: '1px solid #dccfc8', borderRadius: '8px', fontSize: '13px', marginBottom: '10px' }} />
        <textarea value={message} onChange={e => setMessage(e.target.value)} placeholder="Un petit mot (optionnel)" rows={2} style={{ width: '100%', boxSizing: 'border-box', padding: '10px 12px', border: '1px solid #dccfc8', borderRadius: '8px', fontSize: '13px', resize: 'none', marginBottom: '14px', fontFamily: 'inherit' }} />
        {err && <div style={{ fontSize: '12px', color: '#c03030', marginBottom: '10px', textAlign: 'center' }}>{err}</div>}
        <button onClick={handleDon} disabled={loading} style={{ background: '#8b1a2a', color: '#fff', border: 'none', borderRadius: '8px', padding: '13px', fontSize: '14px', fontWeight: '600', cursor: loading ? 'wait' : 'pointer', width: '100%', marginBottom: '10px', opacity: loading ? 0.7 : 1 }}>{loading ? 'Redirection…' : 'Faire un don' + (Number(finalAmount) >= 1 ? ' de ' + Number(finalAmount) + ' €' : '')}</button>
        <div style={{ textAlign: 'center' }}><span onClick={onClose} style={{ fontSize: '12px', color: '#9a8080', cursor: 'pointer' }}>Non merci, peut-être une prochaine fois</span></div>
        <div style={{ textAlign: 'center', marginTop: '14px', fontSize: '12px', color: '#b0a0a0' }}>🔒 Paiement sécurisé par Stripe</div>
      </div>
    </div>
  );
}

const menuSections = [
  { group: 'PARTICIPER', items: [
    { icon: '✦', label: 'Témoigner', path: '/temoigner', highlight: true },
    { icon: '♥', label: 'Contribuer', action: 'popup', highlight: true },
  ]},
  { group: 'TÉMOIGNAGES', items: [
    { icon: '🏠', label: 'Accueil', path: '/' },
    { icon: '📍', label: 'Sur scène & sur la route', path: '/scene', count: 247 },
    { icon: '🤝', label: 'Rencontres & hasards', path: '/rencontres', count: 134 },
    { icon: '✨', label: 'Et si…', path: '/etsi', count: 89 },
    { icon: '🎨', label: 'Art des fans', path: '/art', count: 48 },
        { icon: '🎬', label: 'Le documentaire', path: '/documentaire', count: 56 },
  ]},
  { group: 'MICHAEL', items: [
    { icon: 'ℹ️', label: 'Infos, photos & vidéos', path: '/michael' },
    { icon: '🎨', label: 'Son art graphique', path: '/michael/art-graphique' },
    { icon: '👶', label: 'Michael & les enfants', path: '/michael/enfants' },
    { icon: '👥', label: 'Son entourage', path: '/michael/entourage' },
  ]},
  { group: 'COMMUNAUTÉ', items: [
    { icon: '📰', label: 'Actu membres', path: '/actus' },
    { icon: '✨', label: 'La legende continue', path: '/legende' },
    { icon: '📺', label: 'Live Cams', path: '/live' },
    { icon: '❤️', label: 'Rencontres fans', path: '/rencontres-fans' },
  ]},
  { group: 'MON COMPTE', items: [
    { icon: '👤', label: 'Mon profil', path: '/profil' },
    { icon: '✦', label: 'Mes témoignages', path: '/profil' },
  ]},
  { group: 'LANGUE', items: [
    { icon: '🌐', label: 'Changer de langue', action: 'lang' },
  ]},
];

const btnStyle = {
  display: 'flex', alignItems: 'center', gap: '7px',
  fontSize: '13px', padding: '7px 14px', borderRadius: '7px',
  color: '#fff', textDecoration: 'none', fontWeight: '500',
  background: 'transparent', border: 'none', cursor: 'pointer',
  height: '34px', fontFamily: 'Arial,sans-serif', whiteSpace: 'nowrap'
};

export default function Navbar() {
  const { user, logout } = useAuth();
  const [showPopup, setShowPopup] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [showLang, setShowLang] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [lang, setLang] = useState('FR');
  const navigate = useNavigate();

  const langs = [
    { code: 'FR', flag: 'fr', label: 'Français' },
    { code: 'EN', flag: 'gb', label: 'English' },
    { code: 'DE', flag: 'de', label: 'Deutsch' },
    { code: 'ES', flag: 'es', label: 'Español' },
    { code: '中文', flag: 'cn', label: '中文' },
    { code: 'हि', flag: 'in', label: 'हिन्दी' },
    { code: 'AR', flag: 'sa', label: 'العربية' },
  ];

  return (
    <>
      <nav style={{ background: 'rgba(20,8,12,0.95)', backdropFilter: 'blur(6px)', borderBottom: '1px solid rgba(255,255,255,0.08)', position: 'sticky', top: 0, zIndex: 100 }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 32px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '54px' }}>
          <Link to="/" style={{ fontFamily: 'Georgia,serif', fontSize: '13px', fontWeight: '500', color: '#fff', letterSpacing: '0.04em', textDecoration: 'none', whiteSpace: 'nowrap' }}>
            MJ <span style={{ color: '#e8a0a0' }}>—</span> <span className="nav-hide-mobile">Vu par ceux qui l'ont aimé</span>
          </Link>
          <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
            <span className="nav-hide-mobile" style={{ display: 'contents' }}>
            <Link to="/live" style={{ ...btnStyle }}>
              <span style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#e03030', flexShrink: 0, display: 'inline-block', animation: 'pulse 1.5s ease-in-out infinite' }} />
              Live
            </Link>
            <Link to="/rencontres-fans" style={{ ...btnStyle }}>❤️ Rencontres</Link>
            <div style={{ width: '0.5px', height: '20px', background: 'rgba(255,255,255,0.15)', margin: '0 2px' }} />
            <Link to="/temoigner" style={{ ...btnStyle, background: '#8b1a2a' }}>✦ Témoigner</Link>
            <button onClick={() => setShowPopup(true)} style={{ ...btnStyle, background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.35)' }}>♥ Contribuer</button>
            <div style={{ width: '0.5px', height: '20px', background: 'rgba(255,255,255,0.15)', margin: '0 2px' }} />

            {/* CONNEXION / PROFIL */}
            {user ? (
              <div style={{ position: 'relative' }}>
                <button onClick={() => setShowUserMenu(!showUserMenu)} style={{ ...btnStyle, background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', gap: '8px' }}>
                  <div style={{ width: '24px', height: '24px', borderRadius: '50%', background: '#8b1a2a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', overflow: 'hidden', flexShrink: 0 }}>
                    {user.photo ? <img src={user.photo} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : user.avatar}
                  </div>
                  {user.username}
                </button>
                {showUserMenu && (
                  <div style={{ position: 'absolute', top: '42px', right: 0, background: '#fff', borderRadius: '8px', boxShadow: '0 8px 24px rgba(0,0,0,0.15)', overflow: 'hidden', minWidth: '160px', zIndex: 200 }}>
                    <Link to="/profil" onClick={() => setShowUserMenu(false)} style={{ display: 'block', padding: '11px 16px', fontSize: '13px', color: '#1a1010', textDecoration: 'none', borderBottom: '1px solid #dccfc8' }}>👤 Mon profil</Link>
                    <Link to="/profil" onClick={() => setShowUserMenu(false)} style={{ display: 'block', padding: '11px 16px', fontSize: '13px', color: '#1a1010', textDecoration: 'none', borderBottom: '1px solid #dccfc8' }}>✦ Mes témoignages</Link>
                    <div onClick={() => { logout(); setShowUserMenu(false); navigate('/'); }} style={{ padding: '11px 16px', fontSize: '13px', color: '#c03030', cursor: 'pointer', fontWeight: '600' }}>🚪 Se déconnecter</div>
                  </div>
                )}
              </div>
            ) : (
              <Link to="/connexion" style={{ ...btnStyle, background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)' }}>👤 Connexion</Link>
            )}

            {/* LANGUE */}
            <div className="lang-hidden" style={{ position: 'relative' }}>
              <button onClick={() => setShowLang(!showLang)} style={{ ...btnStyle, background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', gap: '5px' }}>
                <img src={`https://flagcdn.com/20x15/${langs.find(l => l.code === lang)?.flag}.png`} alt="" style={{ width: '16px', height: '12px', borderRadius: '2px' }} />
                {lang} ▾
              </button>
              {showLang && (
                <div style={{ position: 'absolute', top: '42px', right: 0, background: '#fff', borderRadius: '8px', boxShadow: '0 8px 24px rgba(0,0,0,0.15)', overflow: 'hidden', minWidth: '150px', zIndex: 200 }}>
                  {langs.map(l => (
                    <div key={l.code} onClick={() => { setLang(l.code); setShowLang(false); }}
                      style={{ padding: '10px 16px', fontSize: '13px', color: l.code === lang ? '#8b1a2a' : '#1a1010', background: l.code === lang ? '#f5eeeb' : 'transparent', cursor: 'pointer', fontWeight: l.code === lang ? '600' : '400', display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <img src={`https://flagcdn.com/20x15/${l.flag}.png`} alt="" style={{ width: '16px', height: '12px', borderRadius: '2px' }} />
                      {l.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
            </span>

            {user && <NotificationBell token={localStorage.getItem('mjtoken')} />}
            <button onClick={() => setShowMenu(true)} style={{ ...btnStyle, background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.2)' }}>☰ Menu</button>
          </div>
        </div>
      </nav>

      <style>{`@keyframes pulse{0%,100%{transform:scale(1);box-shadow:0 0 0 0 rgba(224,48,48,0.7)}50%{transform:scale(1.2);box-shadow:0 0 0 6px rgba(224,48,48,0)}}`}</style>

      {showMenu && (
        <div onClick={() => setShowMenu(false)} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 500 }}>
          <div onClick={e => e.stopPropagation()} style={{ position: 'absolute', top: 0, right: 0, width: '300px', height: '100%', background: 'rgba(10,4,6,0.97)', backdropFilter: 'blur(20px)', borderLeft: '1px solid rgba(255,255,255,0.1)', overflowY: 'auto' }}>
            <div style={{ padding: '16px 20px', borderBottom: '1px solid rgba(255,255,255,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ fontSize: '12px', letterSpacing: '0.12em', color: 'rgba(255,255,255,0.4)' }}>— NAVIGATION</div>
              <button onClick={() => setShowMenu(false)} style={{ background: 'rgba(255,255,255,0.1)', border: 'none', color: '#fff', borderRadius: '6px', width: '28px', height: '28px', cursor: 'pointer', fontSize: '14px' }}>✕</button>
            </div>
            {menuSections.map((section, si) => (
              <div key={si} className={section.group === 'PARTICIPER' ? 'menu-mobile-only' : (section.group === 'LANGUE' ? 'lang-hidden' : undefined)}>
                <div style={{ padding: '16px 20px 8px' }}>
                  <div style={{ fontSize: '12px', letterSpacing: '0.14em', color: '#e8a0a0', marginBottom: '8px' }}>{section.group}</div>
                  {section.items.map((item, ii) => (
                      <div key={ii} onClick={() => {
                          setShowMenu(false);
                          if (item.action === 'popup') setShowPopup(true);
                          else if (item.action === 'lang') setShowLang(true);
                          else if (item.path) navigate(item.path);
                        }}
                        style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 12px', borderRadius: '8px', cursor: 'pointer', marginBottom: '2px', background: item.highlight ? '#8b1a2a' : 'transparent' }}
                        onMouseEnter={e => e.currentTarget.style.background = item.highlight ? '#6d1420' : 'rgba(255,255,255,0.07)'}
                        onMouseLeave={e => e.currentTarget.style.background = item.highlight ? '#8b1a2a' : 'transparent'}>
                        <div style={{ fontSize: '16px', width: '22px', textAlign: 'center' }}>{item.icon}</div>
                        <div style={{ fontSize: '13px', color: '#fff', flex: 1 }}>{item.label}</div>
                        {item.count && <div style={{ fontSize: '12px', color: '#e8a0a0' }}>{item.count}</div>}
                      </div>
                  ))}
                </div>
                {si < menuSections.length - 1 && <div style={{ height: '0.5px', background: 'rgba(255,255,255,0.06)', margin: '4px 20px' }} />}
              </div>
            ))}
            <div className="menu-mobile-only" style={{ padding: '8px 20px 24px' }}>
              <div style={{ height: '0.5px', background: 'rgba(255,255,255,0.06)', margin: '4px 0 12px' }} />
              {user ? (
                <div onClick={() => { logout(); setShowMenu(false); navigate('/'); }}
                  style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 12px', borderRadius: '8px', cursor: 'pointer' }}>
                  <div style={{ fontSize: '16px', width: '22px', textAlign: 'center', color: '#e8a0a0' }}>↩</div>
                  <div style={{ fontSize: '13px', color: '#e8a0a0' }}>Se déconnecter</div>
                </div>
              ) : (
                <div onClick={() => { navigate('/connexion'); setShowMenu(false); }}
                  style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '11px 12px', borderRadius: '8px', cursor: 'pointer', background: 'rgba(255,255,255,0.08)' }}>
                  <div style={{ fontSize: '16px', width: '22px', textAlign: 'center' }}>→</div>
                  <div style={{ fontSize: '13px', color: '#fff' }}>Connexion</div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {showPopup && <PopupContribuer onClose={() => setShowPopup(false)} />}
    </>
  );
}
